import type { IconName } from '@/shared/ui/Icon'
import type { CatalogOfferKind, CatalogProduct } from './types'

/** Признак строки: маркетинговый (`offer.kind`), «требует подтверждения», «ожидается поставка». */
export type ProductMarkId = CatalogOfferKind | 'confirmation' | 'incoming'
export type ProductMarkTone = 'accent' | 'danger' | 'success' | 'warning' | 'neutral'

export type ProductMark = {
  id: ProductMarkId
  icon: IconName
  tone: ProductMarkTone
  /** Условия акции или пометка транзита — как пришли; `null` — нет. */
  note: string | null
}

/** Значок и тон признака: свои глифы кита, иконки легаси не переносятся (`icon.md`). */
export const PRODUCT_MARK_LOOK = {
  promo: { icon: 'megaphone', tone: 'accent' },
  sale: { icon: 'tagPercent', tone: 'danger' },
  new: { icon: 'sparkles', tone: 'success' },
  confirmation: { icon: 'hourglass', tone: 'warning' },
  incoming: { icon: 'truck', tone: 'neutral' },
} as const satisfies Record<ProductMarkId, { icon: IconName; tone: ProductMarkTone }>

export type ProductMarkSource = Pick<CatalogProduct, 'offer' | 'requiresConfirmation' | 'stock'>

/**
 * Признаки товара в порядке важности для заказа: маркетинговый признак, затем «требует
 * подтверждения», затем «ожидается поставка». Всё — поля ответа как есть; признаки независимы,
 * у товара их бывает несколько.
 */
export function marksOf(product: ProductMarkSource): ProductMark[] {
  const marks: ProductMark[] = []
  if (product.offer !== null) {
    marks.push({
      id: product.offer.kind,
      ...PRODUCT_MARK_LOOK[product.offer.kind],
      note: product.offer.note,
    })
  }
  if (product.requiresConfirmation) {
    marks.push({ id: 'confirmation', ...PRODUCT_MARK_LOOK.confirmation, note: null })
  }
  if (product.stock.incomingSupply) {
    marks.push({ id: 'incoming', ...PRODUCT_MARK_LOOK.incoming, note: product.stock.incomingNote })
  }
  return marks
}
